import { useMemo, useState, useEffect } from 'react';
import { useRequest } from 'ahooks';
import { setLikeInsightsReport } from '@intelligence/services/reportService';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import type { IPDFPreviewDownloadLikeShareURLSearchParams } from '../types';
import {
  formatReportLike,
  NEW_PDF_PREVIEW_STYLE_REPORTS,
} from '@intelligence/pages/InsightsReport/_config';

interface IUseLikeProps extends IPDFPreviewDownloadLikeShareURLSearchParams {
  setLikeBubble: React.Dispatch<React.SetStateAction<boolean>>;
  setShareBubble: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useLike(props: IUseLikeProps) {
  const { systemId, resourceId, resourceLike, setLikeBubble, setShareBubble, reportObject } = props;
  const { logMsgCur } = reportObject || {};
  const [likeCnt, setLikeCnt] = useState(0);

  const likeCntFormatted = useMemo<string>(() => formatReportLike(likeCnt), [likeCnt]);

  const isNewStyleReports = NEW_PDF_PREVIEW_STYLE_REPORTS.includes(systemId);

  const handleLike = async () => {
    try {
      await setLikeInsightsReport({
        system: systemId,
        resource_id: resourceId || '',
      });

      setLikeCnt((likeCnt) => likeCnt + 1);
      setLikeBubble(true);
      setShareBubble(false);
      if (logMsgCur) {
        // 将新展示样式的报告，点赞埋点只传 resourceId
        if (isNewStyleReports) {
          logMsgCur.extInfo = resourceId;
        }
        buriedBtnPoint(logMsgCur);
      }

      setTimeout(() => {
        setLikeBubble(false);
      }, 4000);
    } catch (e) {
      console.log(e);
    }
  };

  const { run: handleLikeRun } = useRequest(handleLike, {
    // 允许连续多次点击刷赞
    throttleWait: isNewStyleReports ? undefined : 3000,
    throttleTrailing: false,
    manual: true,
  });

  useEffect(() => {
    let resourceLikeNum = Number.parseInt(resourceLike, 10);
    resourceLikeNum = Number.isNaN(resourceLikeNum) ? 0 : resourceLikeNum;
    setLikeCnt(resourceLikeNum);
  }, [resourceLike]);

  return {
    likeCnt: likeCntFormatted,
    onLike: handleLikeRun,
  };
}
